module.exports = __webpack_public_path__ + "static/media/image13.d305bb7a.webp";